import { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Handshake, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

const NONE = 'none';

export const LeasingLinkCard = ({ el }) => {
    const [companies, setCompanies] = useState([]);
    const [selected, setSelected] = useState(NONE);
    const [saving, setSaving] = useState(false);
    const [available, setAvailable] = useState(false);

    useEffect(() => {
        Promise.all([api.get('/leasing/companies'), api.get('/leasing/my-link')])
            .then(([c, link]) => {
                setCompanies(c.data);
                setSelected(link.data.leasing_company_id || NONE);
                setAvailable(true);
            })
            .catch(() => setAvailable(false));
    }, []);

    if (!available) return null;

    const save = async () => {
        setSaving(true);
        try {
            await api.put('/leasing/my-link', { leasing_company_id: selected === NONE ? null : selected });
            toast.success(el ? 'Η σύνδεση Leasing αποθηκεύτηκε' : 'Leasing link saved');
        } catch (error) {
            toast.error(error.response?.data?.detail || (el ? 'Αποτυχία αποθήκευσης' : 'Save failed'));
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="fleet-card p-6" data-testid="leasing-link-card">
            <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-amber-500/10 rounded-sm flex items-center justify-center">
                    <Handshake className="w-5 h-5 text-amber-600" />
                </div>
                <div>
                    <h2 className="text-base md:text-lg font-semibold text-slate-800">Leasing</h2>
                    <p className="text-sm text-zinc-500">
                        {el ? 'Επιλέξτε την εταιρεία leasing σας για αυτόματη σύνδεση των οχημάτων σας'
                            : 'Select your leasing company to link your vehicles automatically'}
                    </p>
                </div>
            </div>
            <div className="flex flex-col md:flex-row gap-3">
                <Select value={selected} onValueChange={setSelected}>
                    <SelectTrigger className="md:w-80 bg-white border-slate-300" data-testid="leasing-link-select">
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent className="bg-white border-slate-200">
                        <SelectItem value={NONE}>{el ? 'Χωρίς leasing' : 'No leasing'}</SelectItem>
                        {companies.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
                    </SelectContent>
                </Select>
                <Button onClick={save} disabled={saving} className="bg-[#1B7EB5] hover:bg-[#58A6B4] text-white rounded-sm" data-testid="leasing-link-save-btn">
                    {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : (el ? 'Αποθήκευση' : 'Save')}
                </Button>
            </div>
        </div>
    );
};
